<template>
  <div class="home">
    <div class="banner">
      <div class="banner-badge"><ui-icon name="ball" size="sm" color="white" /> 专业培训</div>
      <h1>乒乓球培训</h1>
      <p>刷脸签到 · 智能课时管理</p>
    </div>

    <div v-if="isAdmin" class="status-tip admin-tip">
      <span>管理员 {{ adminName }} 已登录</span>
      <a @click="handleAdminLogout">退出</a>
    </div>
    <div v-if="isParent" class="status-tip parent-tip">
      <span>家长 {{ parentName }} 已登录</span>
      <a @click="handleParentLogout">退出</a>
    </div>

    <div class="cta-card" @click="$router.push('/checkin')">
      <ui-icon name="camera" size="md" color="blue" />
      <div class="cta-text">
        <div class="cta-title">刷脸签到</div>
        <div class="cta-desc">识别身份，自动扣除课时</div>
      </div>
      <ui-icon name="arrow" size="sm" color="blue" class="cta-arrow-icon" />
    </div>

    <div class="section-head"><span class="section-title">常用服务</span></div>
    <div class="service-grid">
      <div class="service-item" @click="$router.push('/records')">
        <ui-icon name="list" size="md" color="green" />
        <span class="service-name">我的课时</span>
        <span class="service-desc">剩余与记录</span>
      </div>
      <div class="service-item" @click="goParent">
        <ui-icon name="family" size="md" color="amber" />
        <span class="service-name">{{ isParent ? '孩子课时' : '家长登录' }}</span>
        <span class="service-desc">{{ isParent ? '查看自家孩子' : '手机号登录' }}</span>
      </div>
      <div class="service-item" @click="goAdmin">
        <ui-icon name="setting" size="md" color="purple" />
        <span class="service-name">{{ isAdmin ? '管理后台' : '管理员' }}</span>
        <span class="service-desc">{{ isAdmin ? '学员课时管理' : '机构登录' }}</span>
      </div>
      <router-link class="service-item" to="/about">
        <ui-icon name="book" size="md" color="blue" />
        <span class="service-name">使用说明</span>
        <span class="service-desc">服务与帮助</span>
      </router-link>
    </div>

    <div class="card guide-card">
      <div class="guide-header">
        <span class="guide-title">三步上手</span>
        <router-link to="/about" class="guide-more">详情 ›</router-link>
      </div>
      <div class="guide-steps">
        <div class="guide-step"><span class="guide-num">1</span><span>机构录入学员信息</span></div>
        <div class="guide-step"><span class="guide-num">2</span><span>机构为学生录入人脸</span></div>
        <div class="guide-step"><span class="guide-num">3</span><span>下课后刷脸签到扣课时</span></div>
      </div>
    </div>

    <div class="footer-links">
      <router-link to="/privacy">隐私保护指引</router-link>
      <span>·</span>
      <router-link to="/about">服务说明</router-link>
    </div>
  </div>
</template>

<script>
import UiIcon from '../../components/UiIcon.vue'
import { parentLogoutApi } from '../../api'
import {
  isAdminLoggedIn, getAdminUsername, adminLogout,
  isParentLoggedIn, getParentName, parentLogout
} from '../../utils/auth'

export default {
  name: 'Home',
  components: { UiIcon },
  data() {
    return {
      isAdmin: false,
      adminName: '',
      isParent: false,
      parentName: ''
    }
  },
  activated() { this.refreshStatus() },
  mounted() { this.refreshStatus() },
  methods: {
    refreshStatus() {
      this.isAdmin = isAdminLoggedIn()
      this.adminName = getAdminUsername()
      this.isParent = isParentLoggedIn()
      this.parentName = getParentName()
    },
    goParent() {
      if (isParentLoggedIn()) this.$router.push('/records')
      else this.$router.push('/parent/login?redirect=records')
    },
    goAdmin() {
      if (isAdminLoggedIn()) this.$router.push('/dashboard')
      else this.$router.push('/login')
    },
    handleAdminLogout() {
      this.$confirm('确定退出管理员账号？', '退出登录').then(() => {
        adminLogout()
        this.refreshStatus()
        this.$message.success('已退出登录')
      }).catch(() => {})
    },
    handleParentLogout() {
      this.$confirm('确定退出家长账号？', '退出登录').then(async () => {
        try { await parentLogoutApi() } catch (e) { /* ignore */ }
        parentLogout()
        this.refreshStatus()
        this.$message.success('已退出登录')
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.banner {
  background: linear-gradient(135deg, #6366F1, #8B5CF6);
  border-radius: 16px;
  padding: 32px 24px;
  color: #fff;
  margin-bottom: 16px;
}
.banner-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(255,255,255,0.2);
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 12px;
  margin-bottom: 12px;
}
.banner h1 { font-size: 26px; font-weight: 800; margin-bottom: 6px; }
.banner p { font-size: 14px; opacity: 0.88; }
.status-tip {
  display: flex; justify-content: space-between; align-items: center;
  background: #fff; border-radius: 12px; padding: 12px 16px; margin-bottom: 16px; font-size: 14px;
}
.status-tip a { color: #EF4444; cursor: pointer; }
.parent-tip { border-left: 4px solid #10B981; }
.admin-tip { border-left: 4px solid #6366F1; }
.cta-card {
  display: flex; align-items: center; gap: 16px;
  background: #fff; border-radius: 16px; padding: 20px 16px; margin-bottom: 20px;
  cursor: pointer; box-shadow: 0 8px 24px rgba(99,102,241,0.12);
}
.cta-text { flex: 1; }
.cta-title { font-size: 17px; font-weight: 700; color: #1E293B; }
.cta-desc { font-size: 13px; color: #64748B; margin-top: 4px; }
.cta-arrow-icon { margin-left: auto; background: #EEF2FF !important; }
.section-head { margin-bottom: 12px; }
.section-title { font-size: 15px; font-weight: 700; color: #64748B; }
.service-grid {
  display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 20px;
}
.service-item {
  background: #fff; border-radius: 14px; padding: 16px 14px;
  box-shadow: 0 2px 12px rgba(15,23,42,0.04); cursor: pointer; text-decoration: none; color: inherit;
  display: flex; flex-direction: column; align-items: flex-start;
}
.service-name { font-size: 14px; font-weight: 600; color: #1E293B; margin-top: 12px; }
.service-desc { font-size: 11px; color: #94A3B8; margin-top: 4px; }
.card { background: #fff; border-radius: 14px; padding: 16px; box-shadow: 0 2px 12px rgba(15,23,42,0.04); }
.guide-header { display: flex; justify-content: space-between; margin-bottom: 12px; }
.guide-title { font-size: 15px; font-weight: 700; }
.guide-more { font-size: 13px; color: #6366F1; text-decoration: none; }
.guide-step { display: flex; align-items: center; margin-bottom: 10px; font-size: 13px; color: #64748B; }
.guide-num {
  width: 22px; height: 22px; background: #EEF2FF; color: #6366F1;
  border-radius: 50%; text-align: center; line-height: 22px; font-size: 12px; margin-right: 10px;
}
.footer-links { display: flex; justify-content: center; gap: 12px; padding: 24px 0; font-size: 13px; }
.footer-links a { color: #6366F1; text-decoration: none; }
.footer-links span { color: #CBD5E1; }
</style>
